import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Input, Label, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Toast from "../../../../../Components/Common/Toast";
import ActionButton from "../../../../../Components/Common/ActionButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import { HandleErrorMessage } from "../../../../../Components/Common/HandleErrorMessage";
import { CommanDataTables } from "../../../../../Components/Common/DashboardDataTbale";
import { APIClient } from "../../../../../helpers/api_helper";
import { ADD_LEAD_STATUS, DELETE_LEAD_STATUS, GET_LEAD_STATUS, UPDATE_LEAD_STATUS } from "../../../../../helpers/url_helper";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import CommonModal from "../../../../../Components/Common/CommonModal";

const LeadChangeStatus = () => {
    const [leadStatusdatacheck, setLeadStatusdatacheck] = useState([]);
    const [isAddLeadStatus, setIsAddLeadStatus] = useState(false);
    const [leadStatus, setLeadStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [leadTodo, setLeadTodo] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updatingId, setUpdatingId] = useState(null);
    const [modalTitle, setModalTitle] = useState("Add Lead Status");
    //filter 
    const [filterData, setFilteredData] = useState([]);
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");

    const api = new APIClient();


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            status: "",
            description: "",
            isActive: "Active",
        },
        validationSchema: Yup.object({
            status: Yup.string().required('Please enter status'),
            // description: Yup.string().required("Please enter description"),
            isActive: Yup.string().required("Active or Inactive is required"),
        }),
        onSubmit: async (value) => {
            try {
                // setIsLoading(true);
                let data = {
                    status: value.status,
                    description: value.description,
                    isActive: value.isActive,
                    statusId: value._id
                };

                let response;
                if (updatingId) {
                    response = await api.patch(`${UPDATE_LEAD_STATUS}`, {
                        ...data,
                        statusId: updatingId,
                    });
                } else {
                    response = await api.create(`${ADD_LEAD_STATUS}`, data);
                }

                if (response.success === true) {

                    Toast(response?.message, "success");
                    formik.resetForm();
                    setIsAddLeadStatus(false);
                    setUpdatingId(null);
                    await getAllLeadStatus()
                }
            } catch (error) {
                HandleErrorMessage(error);
            } finally {
                setIsLoading(false);
            }
        }
    });

    const getAllLeadStatus = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`${GET_LEAD_STATUS}`);
            if (response.success === true) {
                setIsLoading(false);
                const formattedData = response.data.map((lead, index) => ({
                    _id: lead._id,
                    statuslead: lead.status,
                    statusdescription: lead.description,
                    statusEnableDisable: lead.isActive,
                    statuscreatedate: lead.createdAt,
                }))
                setLeadStatusdatacheck(formattedData);
                setFilteredData(formattedData);

            }
        } catch (error) {
            console.error("Error fetching lead status:", error);

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getAllLeadStatus()
    }, [currentPage, perPage])

    const onDeleteClick = useCallback(async (row) => {
        if (row && row._id) {
            try {
                const response = await api.delete(`${DELETE_LEAD_STATUS}`, {
                    data: { statusId: row._id },
                });

                if (response.success) {
                    setDeleteModal(false);

                    setLeadStatusdatacheck((prev) =>
                        prev.filter((item) => item._id !== row._id)
                    );
                    setLeadStatus((prev) =>
                        prev.filter((item) => item._id !== row._id)
                    );

                    Toast("Lead Status deleted successfully", "success");
                } else {
                    Toast(response?.message || "Failed to delete Lead Status", "error");
                }
            } catch (error) {
                console.error("Error occurred while deleting:", error);
                Toast("An error occurred while deleting the Lead Status", "error");
            }
        }
    }, []);

    //active and inactive toggle 
    const handleStatusToggle = async (row) => {
        const newStatus = row.statusEnableDisable === "Active" ? "Inactive" : "Active";

        try {
            const payload = {
                statusId: row._id,
                isActive: newStatus,
            };
            const response = await api.patch(UPDATE_LEAD_STATUS, payload);
            if (response.success) {
                setLeadStatusdatacheck(prevData => {
                    const newData = prevData.map(item =>
                        item._id === row._id
                            ? { ...item, statusEnableDisable: newStatus }
                            : item
                    );
                    return newData;
                });
                Toast(`Status updated to ${newStatus}`, "success");
            } else {
                Toast(response?.message || "Failed to update status", "error");
            }
        } catch (error) {
            Toast("An error occurred while updating the status", "error");
        }
    };

    const AddtoggleLeadStatus = () => {
        setIsAddLeadStatus(!isAddLeadStatus);
        setModalTitle();
    };

    const OnEditLeadStatus = async (row) => {
        try {
            // await getAllLeadStatus();
            formik.setFieldValue("status", row.statuslead);
            formik.setFieldValue("description", row.statusdescription);
            formik.setFieldValue("isActive", row.statusEnableDisable);
            formik.setFieldValue("statusId", row._id);

            setUpdatingId(row._id);
            setModalTitle("Update Lead Status");
            setIsAddLeadStatus(true);
        } catch (error) {
            console.error("Error in OnEditLeadStatus:", error);
            Toast("Error loading lead status data", "error");
        }
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const filtered = (leadStatusdatacheck || []).filter((item) =>
            Object.values(item).some((value) =>
                value?.toString()?.toLowerCase()?.includes(searchText?.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [leadStatusdatacheck, searchText]);


    const handlePageChange = (page) => {
        setCurrentPage(page);
      };
     
      const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
      };

    //delete lead status 
    const onClickTodoDelete = (row) => {
        setLeadTodo(row);
        setDeleteModal(true);
    }

    // Back in Lead List
    const handleBack = () => {
        navigate(-1);
    };

    const handleAddLeadStatus = useCallback(() => {
        formik.resetForm();
        formik.setFieldValue("status", "");
        setIsAddLeadStatus(true);
        setModalTitle("Add Lead Status");
    }, [formik]);


        // table column 
    const LeadStatuschanges = [
        {
            name: <span className="font-weight-bold fs-13">S No.</span>,
            selector: (row, index) => index + 1,
            sortable: false,
            width: "80px",
        },

        {
            name: <span className="font-weight-bold fs-13">Lead Status</span>,
            selector: (row) => row.statuslead || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Status Description</span>,
            selector: (row) => row.statusdescription || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Created Date</span>,
            selector: (row) => moment(row.statuscreatedate).format("DD MMM YYYY") || "-",
            sortable: true,
        },

        {
            name: <span className="font-weight-bold fs-13">Enable Disable</span>,
            selector: row => row.statusEnableDisable,
            cell: row => <div className="form-check form-switch form-switch-success mb-3 mt-3">
                <Input checked={row.statusEnableDisable === 'Active' ? 'Active' : ''} className="form-check-input" type="checkbox" role="switch" id={`SwitchCheck_${row._id}`} onChange={() => handleStatusToggle(row)} />
                <Label className="form-check-label" for={`SwitchCheck_${row._id}`}>
                    {row.statusEnableDisable === 'Active' ? 'Active' : 'InActive'}
                </Label>
            </div>,
            sortable: true,
        },

        {
            name: <span className="font-weight-bold fs-13">Action</span>,
            selector: (row) => (
                <>
                    <span className="sn-role-managment-responsive-btn">
                        <Button
                            onClick={() => onClickTodoDelete(row)}
                            className="btn btn-sm btn-soft-danger remove-list"
                        >
                            <i className="ri-delete-bin-5-fill align-bottom" />
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            onClick={() => OnEditLeadStatus(row)}
                            className="btn btn-sm btn-soft-success edit-list">
                            <i className="ri-pencil-fill align-bottom" />
                        </Button>
                    </span>
                </>
            ),
        },
    ];

    return (
        <>
            <ToastContainer />
            <div>
                <div className="page-content">
                    <div className="container-fluid">

                        <Row>
                            <Card>
                                <div className="sn-lead-change-status-card-body mt-4">
                                    <div className="flex-grow-1 ms-2">
                                        <div className="sn-lead-report-manavgment-tble-ui">

                                            <CommonModal
                                                isOpen={isAddLeadStatus}
                                                toggle={AddtoggleLeadStatus}
                                                formik={formik}
                                                modalTitle={modalTitle}
                                                buttonText={"Submit"}
                                                className={"btn-success"}
                                                name={"status"}
                                                onInput={(e) => {
                                                    // Remove non-letter and non-space characters
                                                }}
                                            >

                                                {/* Lead Status Field */}
                                                <Label htmlFor="status" className="form-label form-label">
                                                    Lead Status<span className="text-danger">*</span>
                                                </Label>
                                                <div className="sn-country-code-flag-de">
                                                    <Input
                                                        name="status"
                                                        value={formik.values.status}
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.status && formik.errors.status ? "is-invalid" : ""}
                                                        onChange={formik.handleChange}
                                                    />
                                                    {formik.touched.status && formik.errors.status && (
                                                        <div className="invalid-feedback">{formik.errors.status}</div>
                                                    )}
                                                </div>

                                                {/* Description Field */}
                                                <div className="mt-2">
                                                    <Label htmlFor="description" className="form-label">
                                                        Lead Status Description
                                                    </Label>
                                                </div>
                                                <div className="sn-country-code-flag-de">
                                                    <Input
                                                        name="description"
                                                        value={formik.values.description}
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.description && formik.errors.description ? "is-invalid" : ""}
                                                        onChange={formik.handleChange}
                                                    />
                                                    {formik.touched.description && formik.errors.description && (
                                                        <div className="invalid-feedback">{formik.errors.description}</div>
                                                    )}
                                                </div>

                                            </CommonModal>
                                            <div className="mt-4 mb-4 border-bottom d-flex justify-content-between align-items-center">
                                                <button
                                                    onClick={handleBack}
                                                    className="btn btn-sm border border-rounded shadow backbtn-main mb-4"
                                                >
                                                    <i className="ri-arrow-left-line me-1"></i> Back
                                                </button>

                                                <div className="mb-4">
                                                    <ActionButton
                                                        label={"Add Lead Status"}
                                                        onClick={handleAddLeadStatus}
                                                        color={"danger"}
                                                    />
                                                </div>
                                            </div>
                                            <CommanDataTables
                                                column={LeadStatuschanges}
                                                tableData={filterData}
                                                handlePerRowsChange={handlePerRowsChange}
                                                totalRows={filterData?.length || 0}
                                                isLoading={isLoading}
                                                handlePageChange={handlePageChange}
                                                showSearch={false}
                                                handleSearch={handleSearch}
                                                currentPage={currentPage}
                                                perPage={perPage}
                                                setPerPage={setPerPage}
                                                setCurrentPage={setCurrentPage}
                                            />


                                            <DeleteModal
                                                show={deleteModal}
                                                onDeleteClick={() => onDeleteClick(leadTodo)}
                                                onCloseClick={() => setDeleteModal(false)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Row>

                    </div>
                </div>
            </div>
        </>
    );

}

export default LeadChangeStatus;